var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 54.1982H38.0683L60.235 110.91L82.6894 54.1982H119.755L63.9423 188.452H26.6417L41.9196 152.877L0 54.1982Z",
    fill: "#35007D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.671 154.105C145.407 154.105 155.732 143.78 155.732 131.044C155.732 118.308 145.407 107.983 132.671 107.983C119.935 107.983 109.61 118.308 109.61 131.044C109.61 143.78 119.935 154.105 132.671 154.105Z",
    fill: "#35007D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.309 99.5145H121.794L158.64 11H200L163.309 99.5145Z",
    fill: "#35007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/yahoo.465bcbe74a77fd210e0119663af6c262.svg";
export { ForwardRef as ReactComponent };